import React, { useState } from "react";
import styles from "./page.module.css";
import { Link } from "react-router-dom";

/* ---------------- STEP CARD ---------------- */

const StepCard = ({ stepNo, stepTitle, description }) => {
  return (
    <Link to="" className={styles.stepCard}>
      <div className={styles.stepCardLeft}>
        <div className={styles.stepNo}>{stepNo}</div>
      </div>
      <div className={styles.stepCardRight}>
        <div className={styles.stepTitle}>{stepTitle}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </Link>
  );
};

/* ---------------- STOCK STEPS ---------------- */

const stockSteps = [
  {
    stepNo: "Step 01",
    stepTitle: "Find Your Vehicle",
    description:
      "Search your required vehicle from our vehicles, we have high quality vehicles available for sale at reasonable prices. Check complete vehicle information along with vehicle photos to get clear idea of vehicle condition.",
  },
  {
    stepNo: "Step 02",
    stepTitle: "Get Free Quote & Order",
    description:
      "Send us your details to get a Free Quote for your required vehicle by submitting the Get Fee Quote form on the stock detail page. We will send Proforma Invoice to you with best price.",
  },
  {
    stepNo: "Step 03",
    stepTitle: "Payment",
    description:
      "Complete the payment by Bank Telegraphic Transfer from any bank to our Japan Bank Account. After payment send us the transfer copy as proof.",
  },
  {
    stepNo: "Step 04",
    stepTitle: "Shipment",
    description:
      "After receiving full payment we begin export arrangements for the earliest available vessel and send documents by courier.",
  },
  {
    stepNo: "Step 05",
    stepTitle: "Receive Your Vehicle",
    description:
      "Receive documents, clear the vehicle in your country and complete registration procedures.",
  },
];

/* ---------------- AUCTION STEPS ---------------- */

const auctionSteps = [
  {
    stepNo: "Step 01",
    stepTitle: "Register with Us",
    description:
      "Register for free on our website to access live Japan auto auctions.",
  },
  {
    stepNo: "Step 02",
    stepTitle: "Make Deposit & Access Auction",
    description:
      "Make an advance deposit to activate your auction bidding account.",
  },
  {
    stepNo: "Step 03",
    stepTitle: "Find Car & Make BID",
    description:
      "Search your desired vehicle and place bids through our auction system.",
  },
  {
    stepNo: "Step 04",
    stepTitle: "BID Result & Invoice",
    description:
      "We will notify you of auction results and issue the invoice for the balance payment.",
  },
  {
    stepNo: "Step 05",
    stepTitle: "Shipment and Documents",
    description:
      "After payment confirmation we arrange shipment and prepare documents.",
  },
  {
    stepNo: "Step 06",
    stepTitle: "Receive Vehicle",
    description:
      "Vehicle is shipped to your port and documents sent for customs clearance.",
  },
  {
    stepNo: "Step 07",
    stepTitle: "Drive Your Car",
    description:
      "Complete customs clearance and enjoy your new vehicle.",
  },
];

/* ---------------- MAIN PAGE ---------------- */

const HowToBuy = () => {

  const [method, setMethod] = useState("stock");

  const steps = method === "stock" ? stockSteps : auctionSteps;

  return (
    <div className="main-container">
      <div className={`container-content wrapped-content`}>
        <div className={styles.middleWrapper}>
          <div className={styles.middleTitle}>
            Steps to Buy from Stock & Auction
          </div>
          <div className={styles.middleText}>
            We bring you new markets, new customers, and new opportunities
            for the purchase and sale of used cars. Now you can buy and sell
            a used car safely and comfortably online with just a few clicks.
          </div>
        </div>
        <div className={styles.methodSelector}>
          <button
            className={method === "stock" ? styles.active : ""}
            onClick={() => setMethod("stock")}
          >
            From Stock
          </button>
          <button
            className={method === "auction" ? styles.active : ""}
            onClick={() => setMethod("auction")}
          >
            From Auction
          </button>
        </div>

        {/* STEPS */}
        <div className={styles.stepsGrid}>
          {steps.map((step, i) => (
            <StepCard
              key={i}
              stepNo={step.stepNo}
              stepTitle={step.stepTitle}
              description={step.description}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default HowToBuy;